import { render, staticRenderFns } from "./Palette.vue?vue&type=template&id=d62b3d6a&scoped=true&"
import script from "./Palette.vue?vue&type=script&lang=js&"
export * from "./Palette.vue?vue&type=script&lang=js&"
import style0 from "./Palette.vue?vue&type=style&index=0&id=d62b3d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62b3d6a",
  null
  
)

export default component.exports